import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Modal, Form, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";

const Widgets = ( {open, onHide, tenantId} ) => {
  const effectRan = useRef(false);
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const [ widgets, setWidgets ] = useState([]);
  const [ isActive, setIsActive ] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const { apiKey } = useParams();

  const token = async (type, findTenantId, widgetId) => {
    const t = await getAccessTokenSilently({
      scope: "read:messages",
      audience: `https://${domain}/api/v2/`
    });
    
    if (t != null) {
      apiRequest(t, type, findTenantId, widgetId);
    }
  }

  const tokenPlain = async () => {
    const t = await getAccessTokenSilently({
      scope: "read:messages",
      audience: `https://${domain}/api/v2/`
    })

    if (t != null) {
      return t;
    } else {
      return null;
    }
  }

  const apiRequest = (token, type, findTenantId, widgetId) => {
    var apiUri = "";
    if (type === "create") {
      apiUri = "api/TenantWidgets/CreateTenantWidget";
    } if (type === "delete") {
      apiUri = "api/TenantWidgets/DeleteTenantWidget";
    }

    axios
      .post(apiUri, {
        tenantId: findTenantId,
        widgetsModelId: widgetId
      }, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }).then((resp) => {
        //console.log(resp.data);
      }).catch(function(error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (effectRan.current === false) {
      checkActive();
    }
    return () => {
      effectRan.current = true;
    };
  });

  async function checkActive() {
    try {
      const authToken = await tokenPlain();
      const res = await (
        await axios.get("api/TenantWidgets/TenantWidgetsIsActiveId/" + tenantId, {headers: {
          "Authorization": `Bearer ${authToken}`
        }})
      ).data;
      setWidgets(res);
    } catch (error) {
      console.log(error);
    }
  }

  const handleChange = (event) => {
    const findTenantId = tenantId;
    const widgetId = event.target.id;
    if (event.target.checked) {
      checkActive();
      token("create", findTenantId, widgetId);
    } else {
      checkActive();
      token("delete", findTenantId, widgetId);
    }
    setIsActive((current) => !current);
  };

  return (
    <>
      <Modal show={open} onHide={onHide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Change the widget!</Modal.Title>
        </Modal.Header>

        <Modal.Body className="justify-content-center">
          <Form>
            <Stack gap={5}>
              {widgets.map((widget) =>
                widget.isActive === true ? (
                  <Form.Check
                    key={widget.widgetId}
                    type="switch"
                    id={widget.widgetId}
                    label={widget.name}
                    onChange={handleChange}
                    checked
                  />
                ) : (
                  <Form.Check
                    key={widget.widgetId}
                    type="switch"
                    id={widget.widgetId}
                    label={widget.name}
                    onChange={handleChange}
                  />
                )
              )}
            </Stack>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Widgets;
